// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ReconciliationController = function ($scope, $modal, $locale, $location, Reconciliation, SharedParameters, 
    BlEbicsAvailabilityService, DatepickerUtils, PUtill, gettext, $rootScope) {
    $scope.status = 0;

    if (SharedParameters.getValue('status')) {
        $scope.status = SharedParameters.getValue('status');
        SharedParameters.setValue('status', null);
    }

    $scope.dateRange = { dateFrom: null, dateTo: null };
    $scope.amountFrom = '';
    $scope.amountTo = '';
    $scope.isAscending = false;
    $scope.wasSearching = false;

    BlEbicsAvailabilityService.requestEbicsAvailableFlag();

    $scope.isEbicsAvailable = function () {
        return BlEbicsAvailabilityService.isEbicsAvailable();
    };

    $scope.clearFilter = function () {
        $scope.search = '';
        $scope.updateFilter();
    };

    $scope.updateFilter = function () {
        let bookingDateParams = { };
        DatepickerUtils.setSearchParamsWithStringRange(bookingDateParams, $scope.dateRange);

        const filter = {
            status: $scope.status,
            bookingDateFrom: bookingDateParams.dateFrom,
            bookingDateTo: bookingDateParams.dateTo,
            amountFrom: $scope.amountFrom,
            amountTo: $scope.amountTo,
            searchType: $scope.search && $scope.search.key ? $scope.search.key : 0,
            search: $scope.search ? ($scope.search.label || $scope.search) : '',
            isAscending: $scope.isAscending
        };

        $scope.transactions = $scope.paginator(function (options, callback) {
            return Reconciliation.query(options, function () {
                callback();
                $scope.wasSearching = true;
            });
        }, filter, 20);
    };

    let updateFilterTimer = null;
    $scope.updateFilterWithDelay = function () {
        clearTimeout(updateFilterTimer);
        updateFilterTimer = setTimeout($scope.updateFilter, 700);
    }

    function dateWatch (newValue, oldValue) {
        if (!PUtill.areDatesEqual(newValue, oldValue))
            $scope.updateFilterWithDelay()
    }

    $scope.$watch('dateRange.dateFrom', dateWatch);
    $scope.$watch('dateRange.dateTo', dateWatch);

    $scope.currentBalance = 0;

    $scope.ignore = function (item) {
        Reconciliation.delete({
            transactionId: item.Id,
            setTransactionIgnored: (item.Status === "NotAssigned" || item.Status === "PartiallyAssigned")
        }, function (data) {
            item.Status = data.status;
            $scope.updateFilter();
        });
    };

    $scope.getBalance = function () {
        $scope.currentBalance = $scope.account;
        $scope.currentBalance = '';
        $scope.currentCurrency = '';
    };

    $scope.Assign = function (id) {
        $location.path("/activities/reconciliationAssign/" + id);
    };

    $scope.Details = function (id) {
        SharedParameters.setValue('status', $scope.status);
        $scope.Assign(id);
    };

    $scope.account = 'All';
    $scope.filter = "";
    $scope.searchType = 0;

    $scope.getSearchValue = function (val) {
        return [
            { key: 0, label: val, text: "All:" + val },
            { key: 1, label: val, text: "Account Holder:" + val },
            { key: 2, label: val, text: "Purpose:" + val },
            { key: 3, label: val, text: "Booking Text:" + val }
        ];
    };

    $scope.searchFormatLabel = function (model) {
        if (model)
            return model.label;
    };

    $scope.addReceipt = function () {
        $location.path("/activities/reconciliationManualMode");
    };

    $scope.navigateToImportFromFile = function () {
        $location.path("/activities/reconciliationImport");
    };

    $scope.navigateToImportHistory = function () {
        $location.path("/activities/importHistory");
    };

    $scope.navigateToDownloadFromBank = function () {
        $location.path("/activities/reconciliationDownloadFromBank");
    };

    $scope.getBalance();
    $scope.updateFilter();

    $scope.onlyAssignedFilter = function (assignment) {
        return assignment.UnassignmentLedgerEntryId === undefined;
    }
    
    $scope.isActionButtonDisabled = function() {
        return !$rootScope.adminOrInRole(["Operations", "Finance"]); 
    }
};
ReconciliationController.$inject = ['$scope', '$uibModal', '$locale', '$location', 'Reconciliation', 'SharedParameters',
    'BlEbicsAvailabilityService', 'DatepickerUtils', 'PUtill', 'gettext','$rootScope'];
